import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { TranslocoPipe } from '@jsverse/transloco';

@Component({
    selector: 'big-ui-company-logo',
    templateUrl: './company-logo.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [TranslocoPipe],
})
export class CompanyLogoComponent {
    public readonly showLogo = input<'both' | 'mobile' | 'desktop'>('both');
}
